


















































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DefaultCoin extends Vue {
  @Prop({ default: '32' }) readonly width?: string;
  @Prop({ default: '32' }) readonly height?: string;
}
